import {
    Wallet,
    ArrowDownToLine,
    ArrowUpFromLine,
    Activity,
    ShieldCheck,
    Calculator,
    LineChart,
    Code2,
    FileCheck2,
    Users,
    Clock,
    BarChart3,
} from "lucide-react";

const FEATURES = [
    {
        icon: Wallet,
        title: "Multi-Currency Accounts",
        desc: "Hold and operate balances in USD, GBP, EUR, CAD, AED, SGD and INR from one dashboard.",
        span: "md:col-span-2 md:row-span-2",
        feature: true,
    },
    {
        icon: ArrowDownToLine,
        title: "Import Payments",
        desc: "Outward remittance to 100+ countries with IDPMS auto-filing.",
        span: "",
    },
    {
        icon: ArrowUpFromLine,
        title: "Export Collections",
        desc: "Receive inward USD/GBP/CAD payments at interbank rates.",
        span: "",
    },
    {
        icon: Activity,
        title: "Real-Time Tracking",
        desc: "Status, SWIFT MT103 + delivery ETA on every leg.",
        span: "",
    },
    {
        icon: ShieldCheck,
        title: "Compliance Automation",
        desc: "Form A2, 15CA/CB, EDPMS, IDPMS — auto-generated.",
        span: "md:col-span-2",
    },
    {
        icon: Calculator,
        title: "Live FX Calculator",
        desc: "Pre-trade transparency on every quote.",
        span: "",
    },
    {
        icon: LineChart,
        title: "Dashboard Analytics",
        desc: "FX savings, payout velocity, vendor spend in one view.",
        span: "",
    },
    {
        icon: Code2,
        title: "API Access",
        desc: "Production-grade REST APIs + webhooks.",
        span: "",
    },
    {
        icon: FileCheck2,
        title: "FIRA / FIRC Automation",
        desc: "Auto-issued certificates on every inward payment.",
        span: "md:col-span-2",
    },
    {
        icon: Users,
        title: "Bulk Payments",
        desc: "Upload payout files for 1,000+ beneficiaries.",
        span: "",
    },
    {
        icon: Clock,
        title: "Settlement Promise",
        desc: "INR credited in 24 hrs.",
        span: "",
    },
    {
        icon: BarChart3,
        title: "Smart Reporting",
        desc: "Audit-ready exports, GST + Schedule III ready.",
        span: "",
    },
];

export default function FeaturesGrid() {
    return (
        <section
            id="pricing"
            data-testid="features-section"
            className="bg-white py-24 md:py-32 px-4 md:px-8"
        >
            <div className="mx-auto max-w-7xl">
                <div className="max-w-2xl">
                    <span className="text-xs tracking-[0.25em] uppercase font-bold text-emerald-700">
                        Product features
                    </span>
                    <h2 className="font-heading mt-3 text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-zinc-950">
                        One platform. Every cross-border workflow.
                    </h2>
                    <p className="mt-4 text-zinc-600">
                        Twelve building blocks that replace the spreadsheets, bank portals and
                        compliance back-and-forth you put up with today.
                    </p>
                </div>

                <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 sm:gap-5">
                    {FEATURES.map((f, i) => (
                        <article
                            key={f.title}
                            data-testid={`feature-card-${i}`}
                            data-reveal
                            style={{ "--reveal-delay": `${(i % 6) * 60}ms` }}
                            className={`reveal group relative rounded-2xl border border-zinc-200 bg-white p-6 transition-all hover:-translate-y-0.5 hover:shadow-[0_24px_60px_-24px_rgba(6,78,59,0.25)] hover:border-emerald-300 ${
                                f.span || ""
                            } ${f.feature ? "bg-gradient-to-br from-emerald-50 via-white to-white" : ""}`}
                        >
                            <div
                                className={`inline-flex h-11 w-11 items-center justify-center rounded-xl ${
                                    f.feature
                                        ? "bg-emerald-600 text-white glow-emerald"
                                        : "bg-zinc-100 text-zinc-900 group-hover:bg-emerald-600 group-hover:text-white transition-colors"
                                }`}
                            >
                                <f.icon className="h-5 w-5" />
                            </div>
                            <h3 className="font-heading mt-5 text-lg sm:text-xl font-bold tracking-tight text-zinc-950">
                                {f.title}
                            </h3>
                            <p className="mt-2 text-sm text-zinc-600 leading-relaxed">
                                {f.desc}
                            </p>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
}
